import { Alert, Box } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { UserMode } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";

import { useAiSummaryPolling } from "../../hooks/useAiSummaryPolling";
import { useUserMode } from "../../lib/UserMode";

export function AiSummaryBanner() {
  const { t } = useTranslation("client\\components\\banners\\AiSummaryBanner");
  const { isLoggedIn } = useSession();
  const userMode = useUserMode();
  const isEducatorMode = userMode === UserMode.Educator;
  const { visibleSection, handleDismiss } = useAiSummaryPolling();
  const Link = useLinkComponent();

  // Only show to logged in educators
  if (!isLoggedIn || !isEducatorMode || !visibleSection) {
    return null;
  }

  return (
    <Box flex justifyContent="center" sx={{ backgroundColor: "#CFE6FB" }}>
      <Alert
        severity="info"
        onClose={handleDismiss}
        sx={{
          border: "none",
          borderRadius: 0,
          maxWidth: 1255,
          paddingX: 0,
          marginX: 14,
        }}
      >
        <span>
          <Trans t={t}>
            <Link
              to={`/classroom/${visibleSection}`}
              onClick={handleDismiss}
              style={{
                textDecoration: "underline",
                color: "inherit",
                fontWeight: "500",
              }}
            >
              Click here
            </Link>{" "}
            to review the AI-generated parent class update
          </Trans>
        </span>
      </Alert>
    </Box>
  );
}
